import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { zipCode, sameContact, personCompany } from '../../Helpers/validators';
import { normalizeZip } from '../../Helpers/normalizers';
import ContactSameField from './ContactSameField';
import RenterField from './RenterField';
import StateField from './StateField';
import CountryField from './CountryField';
import { usStatePropType } from '../Insured/StateField';
import { TextInput, EmailInput, PhoneInput, Button } from '@jauntin/react-ui';
import { validators, normalizers } from '@jauntin/utilities';
const { required, email, phoneNumber } = validators;
const { normalizeEmail, normalizePhone } = normalizers;

const Edit = ({
  enabled,
  confirm,
  show,
  valid,
  contactSame,
  contactRenter,
  usStates,
  paymentInfoRef,
  scrollToPosition,
}) =>
  show && (
    <>
      <div className="font-weight-bold">
        Enter a contact for the insurance policy
      </div>
      <div className="font-italic">
        We will use this information to email a copy of your proof of insurance,
        or to contact you about the policy.
      </div>
      <br />
      <div className="form-group">
        <ContactSameField
          name="contactSame"
          validate={[sameContact]}
          disabled={!enabled}
        />
      </div>
      <div id="contactIndividual" className="form-row">
        <Field
          component={TextInput}
          validate={[required]}
          name="contactFirstName"
          label="First Name"
          ariaLabel="First Name"
          placeholder="First Name"
          wrapperClassName="col-sm"
          inputClassName="form-control-lg"
        />
        <Field
          component={TextInput}
          validate={[required]}
          name="contactLastName"
          label="Last Name"
          ariaLabel="Last Name"
          placeholder="Last Name"
          wrapperClassName="col-sm"
          inputClassName="form-control-lg"
        />
      </div>
      <div className="form-row">
        <Field
          component={PhoneInput}
          validate={[required, phoneNumber]}
          normalize={normalizePhone}
          disabled={!enabled}
          name="contactPhone"
          subtext="This will only be used for customer service."
          wrapperClassName="col-sm-6 d-flex flex-column"
          inputClassName="form-control-lg"
          errorClassName="form-group--order-4 my-1 ml-2"
        />
        <Field
          component={EmailInput}
          validate={[required, email]}
          normalize={normalizeEmail}
          disabled={!enabled}
          name="contactEmail"
          subtext="This is where the policy information will be sent."
          wrapperClassName="col-sm-6 d-flex flex-column"
          inputClassName="form-control-lg"
          errorClassName="form-group--order-4 my-1 ml-2"
        />
      </div>
      {!contactSame && (
        <div id="newContactInfo">
          <RenterField name="contactRenter" validate={[personCompany]} />
          {contactRenter && (
            <div id="contactCompany" className="form-row">
              <Field
                component={TextInput}
                validate={[required]}
                name="contactCompany"
                label="Company name"
                ariaLabel="Company name"
                placeholder="Company name"
                wrapperClassName="col-sm"
                inputClassName="form-control-lg"
                errorClassName="d-inline ml-2"
              />
            </div>
          )}
          <Field
            component={TextInput}
            validate={[required]}
            name="contactAddress"
            label="Street Address"
            ariaLabel="Address"
            placeholder="Address"
            subtext="Mailing address, including apartment, suite, unit, building, floor, etc.."
          />
          <div className="form-row">
            <Field
              component={TextInput}
              validate={[required]}
              name="contactCity"
              label="City"
              ariaLabel="City"
              placeholder="City"
              wrapperClassName="col-sm"
              inputClassName="form-control-lg"
            />
            <Field
              component={StateField}
              validate={[required]}
              name="contactState"
              type="select"
              usStates={usStates}
            />
            <Field
              component={TextInput}
              validate={[required, zipCode]}
              normalize={normalizeZip}
              name="contactZip"
              label="Zipcode"
              ariaLabel="Zipcode"
              placeholder="Zipcode"
              pattern="\d*"
              inputMode="numeric"
              wrapperClassName="col-sm"
              inputClassName="form-control-lg"
            />
          </div>
          <div className="form-row" hidden>
            <Field
              component={CountryField}
              validate={[required]}
              name="contactCountry"
              type="select"
              input={{ disabled: true }}
            />
          </div>
        </div>
      )}
      <hr />
      <div className="float-right">
        <Button
          disabled={!valid}
          onClick={() => {
            confirm();
            scrollToPosition(paymentInfoRef);
          }}
          text="Confirm Insurance Contact"
          className="btn-primary"
        />
      </div>
    </>
  );
Edit.propTypes = {
  enabled: PropTypes.bool.isRequired,
  confirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  contactSame: PropTypes.bool.isRequired,
  contactRenter: PropTypes.bool.isRequired,
  usStates: usStatePropType.isRequired,
  paymentInfoRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  scrollToPosition: PropTypes.func.isRequired,
};

export default Edit;
